import {
    createSelector,
} from '@reduxjs/toolkit';

export const selectByKey = ({ clientState }, key) => clientState[key];

export const selectArticlesEnabled = ({ clientState }) => clientState['articles:enabled'];
export const selectBannersEnabled = ({ clientState }) => clientState['banners:enabled'];
export const selectBannersPlaceholderId = ({ clientState }) => clientState['banners:placeholderId'];
export const selectBrandId = ({ clientState }) => clientState['wrapper:brandId'];
export const selectContainerSize = ({ clientState }) => clientState['container:size'];
export const selectDidReceivePRDCMessage = ({ clientState }) => clientState['wrapper:didReceivePRDCMessage'];
export const selectHeartbeatConfig = ({ clientState }) => clientState['heartbeat'];
export const selectIsBuildInfoEnabled = ({ clientState }) => clientState['buildInfoEnabled'];
export const selectIsFtd = ({ clientState }) => clientState['wrapper:isFtd'];
export const selectIsHybrid = ({ clientState }) => clientState['wrapper:isHybrid'];
export const selectIsMobile = ({ clientState }) => clientState['wrapper:isMobile'];
export const selectIsPromotionPermitted = ({ clientState }) => clientState['wrapper:isPromotionPermitted'];
export const selectIsPromotionRestricted = ({ clientState }) => clientState['wrapper:isPromotionRestricted'];
export const selectIsVip = ({ clientState }) => clientState['wrapper:isVip'];
export const selectLanguageIso = ({ clientState }) => clientState['language:iso'].toLowerCase();
export const selectLazyLoadEnabled = ({ clientState }) => clientState['lazyload:enabled'];
export const selectNumberOfMarketsInAllMarkets = ({ clientState }) => clientState['all_markets_group_open_markets'];
export const selectOnboardingPageEnabled = ({ clientState }) => clientState['onboardingPage:enabled'];
export const selectOnboardingPageOpen = ({ clientState }) => clientState['onboardingPage:open'];
export const selectOsName = ({ clientState }) => clientState['wrapper:osName']?.toLowerCase();
export const selectPokerBlastConfig = ({ clientState }) => clientState['pokerblast'];
export const selectRecommendationBetPlacementEnabled = ({ clientState }) => clientState['recommend:betplacement:selection:status'];
export const selectRecommendationBetReceiptEnabled = ({ clientState }) => clientState['recommend:betreceipt:selection:status'];
export const selectRecommendationGlobalEnabled = ({ clientState }) => clientState['recommend:global:selection:status'];
export const selectRecommendationNumberOfBets = ({ clientState }) => clientState['recommend:numberOfBets:selection:status'];
export const selectRecommendationNumberOfBetsThreshold = ({ clientState }) => clientState['recommend:numberOfbBetsThreshold:selection'];
export const selectRmsData = ({ clientState }) => clientState['wrapper:rms'];
export const selectSearchEnabled = ({ clientState }) => clientState['search_enabled'] === '1';
export const selectSerialData = ({ clientState }) => clientState['wrapper:serial'];
export const selectSports = ({ clientState }) => clientState['sports'];
export const selectSportcallerIframeInfo = ({ clientState }) => clientState['sportcaller'];
export const selectSpotlightSports = ({ clientState }) => clientState['spotlight:sports'];
export const selectStateInitialized = ({ clientState }) => clientState['state:init'];
export const selectStatsCenterConfig = ({ clientState }) => clientState['statscenter'];
export const selectVisualisationsConfig = ({ clientState }) => clientState['visualisations'];
export const selectBetslipMaxSelectionsConfig = ({ clientState }) => clientState['betslip:max-selections'];


export const selectBannersContextPlaceholderId = createSelector(
    selectBannersPlaceholderId,
    (_, viewingContext) => viewingContext,
    (placeholderIds, viewingContext) => {
        if (viewingContext === 'generic' && typeof placeholderIds === 'string') {
            return placeholderIds;
        }

        return placeholderIds[viewingContext] || false;
    }
);

export const selectIsIosApp = createSelector(
    selectOsName,
    (osName) => osName === 'ios'
);

export const selectIsAndroidApp = createSelector(
    selectOsName,
    (osName) => osName === 'android'
);

export const selectSportSlugs = createSelector(
    selectSports,
    (sports) => Object.keys(sports)
);
